import { AxiosError, AxiosResponse } from 'axios';

import Config from '../../shared/config';
import LessonWithVersion from '../models/LessonWithVersion';
import useSWR from 'swr';

export function useCourseLessons(coursekey: number, courseVersion: number) {
  const { data: response, error } = useSWR<
    AxiosResponse<LessonWithVersion[]>,
    AxiosError<Error>
  >(
    coursekey && courseVersion
      ? `${Config.API}/api/module/list/module/version/course/${coursekey}/version/${courseVersion}`
      : null
  );

  return {
    lessons: response?.data ?? [],
    loading: !error && !response,
    error
  };
}
